export default "__VITE_ASSET__BaN5Opon__"